import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NgxAimService } from '../../ngx-aim.service';
import { Observable } from 'rxjs';
import { AppPost } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class NgxAimPostsService {
  http = inject(HttpClient);
  ngxAimService = inject(NgxAimService);

  private baseUrl = `${this.ngxAimService.getApiUrl()}/posts`;

  findAllByCategory(category: string): Observable<AppPost[]> {
    return this.http.get<AppPost[]>(`${this.baseUrl}/category/${category}`);
  }

  findOneBySlug(category: string, slug: string): Observable<AppPost> {
    return this.http.get<AppPost>(`${this.baseUrl}/category/${category}/${slug}`);
  }
}
